export default "__VITE_PUBLIC_ASSET__e91d34ed__"